import { useCallback } from 'react';
import useRouterState from '@discover-use-router-state';
import { useStoreActions, useStoreState } from '@discover-data/stores/restaurant/hooks';

export default function useResetTimes() {
  const storeMode = useStoreState((state) => state.mode);
  // have to use the `useRouterState` directly to set both router values since using `setStartTime` and `setEndTime` hooks sequentially would overwrite the first one set
  const setStoreStart = useStoreActions((actions) => actions.times.setStart);
  const setStoreEnd = useStoreActions((actions) => actions.times.setEnd);
  const [, setRouterValues] = useRouterState(['start-time', 'end-time']);

  const resetTimes = useCallback(async () => {
    setStoreStart(null);
    setStoreEnd(null);

    await setRouterValues({
      'start-time': [],
      'end-time': [],
    });
  }, [setStoreStart, setStoreEnd, setRouterValues, storeMode]);

  return resetTimes;
}
